export default {
  font: {
    decorations: {
      none: "Primitives.fonts.decorations['none']",
      underline: "Primitives.fonts.decorations['underline']",
    },
    style: {
      italic: "Primitives.fonts.style['italic']",
      none: "Primitives.fonts.style['none']",
    },
    typeface: {
      heading: "Primitives.fonts.typeface['starJedi']",
      accent: "Primitives.fonts.typeface['starJedi']",
      fancy: "Primitives.fonts.typeface['starJedi']",
      standard: "Primitives.fonts.typeface['tradeGothic']",
      mono: "Primitives.fonts.typeface['monospace']",
    },
    weight: {
      dark: "Primitives.fonts.weight['dark']",
      light: "Primitives.fonts.weight['light']",
      standard: "Primitives.fonts.weight['standard']",
    },
  },
  size: {
    lineHeight: {
      standard: "Primitives.sizes.lineHeight['standard']",
      relaxed: "Primitives.sizes.lineHeight['relaxed']",
    },
    measure: {
      none: "none",
      prose: "Primitives.sizes.measure['prose']",
    },
    font: {
      footnote: "Primitives.sizes.variants['extraSmall']",
      extraSmall: "Primitives.sizes.variants['extraSmall']",
      verySmall: "Primitives.sizes.variants['verySmall']",
      small: "Primitives.sizes.variants['standard']",
      standard: "Primitives.sizes.variants['regular']",
      large: "Primitives.sizes.variants['large']",
      extraLarge: "Primitives.sizes.variants['extraLarge']",
      extraExtraLarge: "Primitives.sizes.variants['extraHuge']",
      huge: "Primitives.sizes.variants['extraHuge']",
      gigantic: "Primitives.sizes.variants['gigantic']",
      displayVerySmall: "Primitives.sizes.variants['huge']",
      displaySmall: "Primitives.sizes.variants['gigantic']",
      displayMedium: "Primitives.sizes.variants['extraGigantic']",
      displayLarge: "Primitives.sizes.variants['veryGigantic']",
    },
    borderRadius: {
      none: "Primitives.sizes.variants['none']",
      small: "Primitives.sizes.variants['veryThin']",
      standard: "Primitives.sizes.variants['thin']",
      large: "Primitives.sizes.variants['extraSmall']",
      extraLarge: "Primitives.sizes.variants['regular']",
      huge: "Primitives.sizes.variants['huge']",
    },
    spacing: {
      none: "Primitives.sizes.variants['none']",
      thin: "Primitives.sizes.variants['extraThin']",
      extraSmall: "Primitives.sizes.variants['thin']",
      small: "Primitives.sizes.variants['extraSmall']",
      standard: "Primitives.sizes.variants['verySmall']",
      large: "Primitives.sizes.variants['regular']",
      extraLarge: "Primitives.sizes.variants['extraLarge']",
      huge: "Primitives.sizes.variants['huge']",
      gigantic: "Primitives.sizes.variants['gigantic']",
      colossal: "Primitives.sizes.variants['extraGigantic']",
    },
    border: {
      none: "Primitives.sizes.variants['none']",
      thin: "Primitives.sizes.variants['hairline']",
      standard: "Primitives.sizes.variants['extraThin']",
      thick: "Primitives.sizes.variants['veryThin']",
    },
    icon: {
      small: "Primitives.sizes.variants['regular']",
      standard: "Primitives.sizes.variants['large']",
      large: "Primitives.sizes.variants['huge']",
    },
    button: {
      small: "Primitives.sizes.variants['huge']",
      standard: "Primitives.sizes.variants['extraHuge']",
      large: "Primitives.sizes.variants['gigantic']",
    },
  },
  color: {
    font: {
      standard: "Semantic.colors.bold[standard]",
      light: "Semantic.colors.bold[fun]",
      subtle: "Semantic.colors.gray[serious]",
      accent: "Semantic.colors.accent[standard]",
      branded: "Semantic.colors.accent[standard]",
      striking: "Semantic.colors.accent[standard]",
      error: "Semantic.colors.warning[serious]",
      warning: "Primitives.colors.yellow[400]",
      success: "Semantic.colors.primary[serious]",
      disabled: "Semantic.colors.gray[fun]",
      informational: "Primitives.colors.blue[400]",
      onMedia: "Primitives.colors.grey[100]",
    },
    border: {
      none: "Primitives.colors.transparent[100]",
      standard: "Semantic.colors.gray[fun]",
      light: "Semantic.colors.gray[serious]",
      dark: "Semantic.colors.gray[standard]",
      darker: "Semantic.colors.bold[standard]",
      striking: "Semantic.colors.accent[standard]",
      disabled: "Semantic.colors.gray[fun]",
    },
    background: {
      none: "Primitives.colors.transparent[100]",
      paper: "Primitives.colors.starfield[500]",
      pure: "Primitives.colors.starfield[500]",
      standard: "Primitives.colors.starfield[500]",
      light: "Primitives.colors.starfield[100]",
      balanced: "Primitives.colors.starfield[200]",
      dimmed: "Primitives.colors.starfield[300]",
      dark: "Primitives.colors.starfield[400]",
      darker: "Primitives.colors.starfield[500]",
      subtle: "Primitives.colors.starfield[200]",
      informational: "Primitives.colors.starfield[200]",
      strikingLight: "Primitives.colors.yellow[200]",
      striking: "Primitives.colors.yellow[600]",
      notice: "Primitives.colors.yellow[700]",
      disabled: "Primitives.colors.starfield[200]",
      success: "Primitives.colors.green[600]",
      warning: "Primitives.colors.yellow[400]",
      error: "Primitives.colors.red[500]",
    },
    chart: {
      series1: "Primitives.colors.blue[200]",
      series2: "Primitives.colors.blue[400]",
      series3: "Primitives.colors.blue[700]",
      series4: "Primitives.colors.purple[400]",
      series5: "Primitives.colors.orange[500]",
      series6: "Primitives.colors.green[600]",
      series7: "Primitives.colors.yellow[700]",
      series8: "Primitives.colors.red[500]",
      seriesMuted: "Primitives.colors.grey[600]",
    },
    gradient: {
      none: "Primitives.colors.transparent[100]",
    },
    boxShadow: {
      none: "Primitives.colors.transparent[100]",
    },
    textShadow: {
      none: "Primitives.colors.transparent[100]",
    },
    icon: {
      standard: "Semantic.colors.bold[standard]",
      light: "Semantic.colors.gray[serious]",
      dark: "Semantic.colors.bold[fun]",
      informational: "Semantic.colors.bold[fun]",
      striking: "Semantic.colors.accent[standard]",
      notice: "Semantic.colors.warning[standard]",
    },
  },
};
